/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'caidanyou': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M106.667 789.12a21.333 21.333 0 00-21.334 21.333v42.667a21.333 21.333 0 0021.334 21.333h810.666a21.333 21.333 0 0021.334-21.333v-42.667a21.333 21.333 0 00-21.334-21.333H106.667zm661.632-408.96l-.299 3.627v256a21.333 21.333 0 0033.621 17.493l2.816-2.39 128-128a21.333 21.333 0 002.432-27.22l-2.432-2.987-128-128a21.333 21.333 0 00-36.138 11.434zM106.667 575.787a21.333 21.333 0 00-21.334 21.333v42.667a21.333 21.333 0 0021.334 21.333h512A21.333 21.333 0 00640 639.787V597.12a21.333 21.333 0 00-21.333-21.333h-512zm0-213.334a21.333 21.333 0 00-21.334 21.334v42.666a21.333 21.333 0 0021.334 21.334h512A21.333 21.333 0 00640 426.453v-42.666a21.333 21.333 0 00-21.333-21.334h-512zm0-213.333a21.333 21.333 0 00-21.334 21.333v42.667a21.333 21.333 0 0021.334 21.333h810.666a21.333 21.333 0 0021.334-21.333v-42.667a21.333 21.333 0 00-21.334-21.333H106.667z"/>'
  }
})
